import React from 'react';
import familyImage from '../images/familia.png';
import promoVideo from '../videos/propaganda.mp4';
import './FamilySection.css';

const FamilySection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="family-section">
      <div className="family-container">
        <div className="family-image-wrapper">
          <video
            src={promoVideo}
            controls
            playsInline
            preload="metadata"
            poster={familyImage}
            className="family-video"
          />
        </div>
        
        <div className="family-content">
          <h2 className="family-title">Proteção para quem você mais ama</h2>
          <p className="family-description">
            Garanta a segurança da sua família com nossa tecnologia de rastreamento. 
            Tenha paz de espírito sabendo exatamente onde estão seus entes queridos, 
            a qualquer hora e em qualquer lugar.
          </p>
          
          <button className="family-cta-btn" onClick={scrollToContact}>
            Proteja sua família agora
          </button>
        </div>
      </div>
    </section>
  );
};

export default FamilySection;

